<template>
  <div :class="{ white: white }">
    <div class="video-wrapper">
      <iframe
        v-if="!white && popupContent.title === 'Moderne burgerij'"
        class="video"
        src="https://youtube.com/embed/TKWtivvObOE"
      ></iframe>
      <iframe
        v-if="!white && popupContent.title === 'Opwaarts mobielen'"
        class="video"
        src="https://youtube.com/embed/2FHndfuw_-8"
      ></iframe>
      <iframe
        v-if="!white && popupContent.title === 'Postmaterialisten'"
        class="video"
        src="https://youtube.com/embed/0vsIoFiE3E0"
      ></iframe>
      <iframe
        v-if="!white && popupContent.title === 'Nieuwe conservatieven'"
        class="video"
        src="https://youtube.com/embed/_u-SYg4Xxis"
      ></iframe>
      <iframe
        v-if="!white && popupContent.title === 'Traditionele burgerij'"
        class="video"
        src="https://youtube.com/embed/8sC5-rXNSrc"
      ></iframe>
      <iframe
        v-if="!white && popupContent.title === 'Kosmopolieten'"
        class="video"
        src="https://youtube.com/embed/jSKfEuZcS8o"
      ></iframe>
      <iframe
        v-if="!white && popupContent.title === 'Postmoderne hedonisten'"
        class="video"
        src="https://youtube.com/embed/JFT2tqxGo6I"
      ></iframe>
      <iframe
        v-if="!white && popupContent.title === 'Gemaksgeorienteerden'"
        class="video"
        src="https://youtube.com/embed/GvRtT9QfzG0"
      ></iframe>
      <iframe v-if="white" class="video" :src="popupContent.video"></iframe>
      <div v-if="white" class="text">
        <span
          class="perc"
          :class="[
            popupContent.cssClass === 'positive' ? 'green' : '',
            popupContent.cssClass === 'negative' ? 'purple' : '',
            popupContent.cssClass === null ? 'grey' : '',
          ]"
          >{{ parseInt(popupContent.percentage) + "%" }}</span
        >
        <p
          v-if="popupContent.cssClass === 'positive'"
          class="body"
          v-html="$t('components.meer')"
        ></p>
        <p
          v-if="popupContent.cssClass === 'negative'"
          class="body"
          v-html="$t('components.minder')"
        ></p>
        <p v-if="popupContent.cssClass === null" class="body">
          {{ $t("components.geen") }}
        </p>
      </div>
    </div>
    <p class="title">{{ popupContent.title }}</p>
    <p class="body">{{ popupContent.description }}</p>
    <div v-if="white" class="row">
      <div class="image" v-for="image in popupContent.images" :key="image.id">
        <div
          class="img"
          :style="{ backgroundImage: `url(${encodeURI(url + image)})` }"
        ></div>
      </div>
    </div>
    <div v-if="!white" class="row">
      <div class="image" v-for="image in allImages" :key="image.id">
        <div
          class="img"
          :style="{ backgroundImage: `url(${image.image})` }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
// import { linkimg } from "@/router/index.js";
// export default {
//   props: {
//     popupContent: Object,
//     white: {
//       type: Boolean,
//       default: false,
//     },
//   },
//   data() {
//     /* eslint-disable */
//     return {
//       url: linkimg,
//       images: {
//         moderneBurgerij: [
//           {
//             image: require("../../assets/Mentality/ModerneBurgerij/image1.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/ModerneBurgerij/image2.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/ModerneBurgerij/image3.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/ModerneBurgerij/image4.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/ModerneBurgerij/image5.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/ModerneBurgerij/image6.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/ModerneBurgerij/image7.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/ModerneBurgerij/image8.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/ModerneBurgerij/image9.jpg"),
//           },
//         ],
//         opwaartsMobielen: [
//           {
//             image: require("../../assets/Mentality/OpwaartsMobielen/image1.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/OpwaartsMobielen/image2.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/OpwaartsMobielen/image3.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/OpwaartsMobielen/image4.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/OpwaartsMobielen/image5.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/OpwaartsMobielen/image6.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/OpwaartsMobielen/image7.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/OpwaartsMobielen/image8.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/OpwaartsMobielen/image9.jpg"),
//           },
//         ],
//         postMaterialisten: [
//           {
//             image: require("../../assets/Mentality/Postmaterialisten/image1.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/Postmaterialisten/image2.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/Postmaterialisten/image3.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/Postmaterialisten/image4.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/Postmaterialisten/image5.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/Postmaterialisten/image6.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/Postmaterialisten/image7.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/Postmaterialisten/image8.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/Postmaterialisten/image9.jpg"),
//           },
//         ],
//         nieuweConservatieven: [
//           {
//             image: require("../../assets/Mentality/NieuweConservatieven/image1.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/NieuweConservatieven/image2.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/NieuweConservatieven/image3.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/NieuweConservatieven/image4.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/NieuweConservatieven/image5.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/NieuweConservatieven/image6.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/NieuweConservatieven/image7.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/NieuweConservatieven/image8.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/NieuweConservatieven/image9.jpg"),
//           },
//         ],
//         traditioneleBurgerij: [
//           {
//             image: require("../../assets/Mentality/TraditioneleBurgerij/image1.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/TraditioneleBurgerij/image2.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/TraditioneleBurgerij/image3.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/TraditioneleBurgerij/image4.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/TraditioneleBurgerij/image5.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/TraditioneleBurgerij/image6.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/TraditioneleBurgerij/image7.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/TraditioneleBurgerij/image8.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/TraditioneleBurgerij/image9.jpg"),
//           },
//         ],
//         kosmopolieten: [
//           { image: require("../../assets/Mentality/Kosmopolieten/image1.jpg") },
//           { image: require("../../assets/Mentality/Kosmopolieten/image2.jpg") },
//           { image: require("../../assets/Mentality/Kosmopolieten/image3.jpg") },
//           { image: require("../../assets/Mentality/Kosmopolieten/image4.jpg") },
//           { image: require("../../assets/Mentality/Kosmopolieten/image5.jpg") },
//           { image: require("../../assets/Mentality/Kosmopolieten/image6.jpg") },
//           { image: require("../../assets/Mentality/Kosmopolieten/image7.jpg") },
//           { image: require("../../assets/Mentality/Kosmopolieten/image8.jpg") },
//           { image: require("../../assets/Mentality/Kosmopolieten/image9.jpg") },
//         ],
//         postmoderneHedonisten: [
//           {
//             image: require("../../assets/Mentality/PostmoderneHedonisten/image1.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/PostmoderneHedonisten/image2.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/PostmoderneHedonisten/image3.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/PostmoderneHedonisten/image4.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/PostmoderneHedonisten/image5.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/PostmoderneHedonisten/image6.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/PostmoderneHedonisten/image7.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/PostmoderneHedonisten/image8.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/PostmoderneHedonisten/image9.jpg"),
//           },
//         ],
//         gemaksgeorienteerden: [
//           {
//             image: require("../../assets/Mentality/Gemaksgeorienteerden/image1.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/Gemaksgeorienteerden/image2.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/Gemaksgeorienteerden/image3.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/Gemaksgeorienteerden/image4.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/Gemaksgeorienteerden/image5.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/Gemaksgeorienteerden/image6.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/Gemaksgeorienteerden/image7.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/Gemaksgeorienteerden/image8.jpg"),
//           },
//           {
//             image: require("../../assets/Mentality/Gemaksgeorienteerden/image9.jpg"),
//           },
//         ],
//       },
//     };
//   },
//   computed: {
//     allImages() {
//       if (this.popupContent.title === "Moderne burgerij") {
//         return this.images.moderneBurgerij.filter(function (image) {
//           return image;
//         });
//       }

//       if (this.popupContent.title === "Opwaarts mobielen") {
//         return this.images.opwaartsMobielen.filter(function (image) {
//           return image;
//         });
//       }

//       if (this.popupContent.title === "Postmaterialisten") {
//         return this.images.postMaterialisten.filter(function (image) {
//           return image;
//         });
//       }

//       if (this.popupContent.title === "Nieuwe conservatieven") {
//         return this.images.nieuweConservatieven.filter(function (image) {
//           return image;
//         });
//       }

//       if (this.popupContent.title === "Traditionele burgerij") {
//         return this.images.traditioneleBurgerij.filter(function (image) {
//           return image;
//         });
//       }

//       if (this.popupContent.title === "Kosmopolieten") {
//         return this.images.kosmopolieten.filter(function (image) {
//           return image;
//         });
//       }

//       if (this.popupContent.title === "Postmoderne hedonisten") {
//         return this.images.postmoderneHedonisten.filter(function (image) {
//           return image;
//         });
//       }

//       if (this.popupContent.title === "Gemaksgeorienteerden") {
//         return this.images.gemaksgeorienteerden.filter(function (image) {
//           return image;
//         });
//       }
//     },
//   },
// };

import { computed, ref } from "vue";
import { useRoute } from "vue-router";
import { linkimg } from "@/router/index.js";

export default {
  props: {
    popupContent: {
      type: Object,
      required: true,
    },
    white: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const url = ref(linkimg);

    // Define images as a dictionary of image arrays
    const images = {
      moderneBurgerij: [
        {
          image: require("../../assets/Mentality/ModerneBurgerij/image1.jpg"),
        },
        {
          image: require("../../assets/Mentality/ModerneBurgerij/image2.jpg"),
        },
        {
          image: require("../../assets/Mentality/ModerneBurgerij/image3.jpg"),
        },
        {
          image: require("../../assets/Mentality/ModerneBurgerij/image4.jpg"),
        },
        {
          image: require("../../assets/Mentality/ModerneBurgerij/image5.jpg"),
        },
        {
          image: require("../../assets/Mentality/ModerneBurgerij/image6.jpg"),
        },
        {
          image: require("../../assets/Mentality/ModerneBurgerij/image7.jpg"),
        },
        {
          image: require("../../assets/Mentality/ModerneBurgerij/image8.jpg"),
        },
        {
          image: require("../../assets/Mentality/ModerneBurgerij/image9.jpg"),
        },
      ],
      opwaartsMobielen: [
        {
          image: require("../../assets/Mentality/OpwaartsMobielen/image1.jpg"),
        },
        {
          image: require("../../assets/Mentality/OpwaartsMobielen/image2.jpg"),
        },
        {
          image: require("../../assets/Mentality/OpwaartsMobielen/image3.jpg"),
        },
        {
          image: require("../../assets/Mentality/OpwaartsMobielen/image4.jpg"),
        },
        {
          image: require("../../assets/Mentality/OpwaartsMobielen/image5.jpg"),
        },
        {
          image: require("../../assets/Mentality/OpwaartsMobielen/image6.jpg"),
        },
        {
          image: require("../../assets/Mentality/OpwaartsMobielen/image7.jpg"),
        },
        {
          image: require("../../assets/Mentality/OpwaartsMobielen/image8.jpg"),
        },
        {
          image: require("../../assets/Mentality/OpwaartsMobielen/image9.jpg"),
        },
      ],
      postMaterialisten: [
        {
          image: require("../../assets/Mentality/Postmaterialisten/image1.jpg"),
        },
        {
          image: require("../../assets/Mentality/Postmaterialisten/image2.jpg"),
        },
        {
          image: require("../../assets/Mentality/Postmaterialisten/image3.jpg"),
        },
        {
          image: require("../../assets/Mentality/Postmaterialisten/image4.jpg"),
        },
        {
          image: require("../../assets/Mentality/Postmaterialisten/image5.jpg"),
        },
        {
          image: require("../../assets/Mentality/Postmaterialisten/image6.jpg"),
        },
        {
          image: require("../../assets/Mentality/Postmaterialisten/image7.jpg"),
        },
        {
          image: require("../../assets/Mentality/Postmaterialisten/image8.jpg"),
        },
        {
          image: require("../../assets/Mentality/Postmaterialisten/image9.jpg"),
        },
      ],
      nieuweConservatieven: [
        {
          image: require("../../assets/Mentality/NieuweConservatieven/image1.jpg"),
        },
        {
          image: require("../../assets/Mentality/NieuweConservatieven/image2.jpg"),
        },
        {
          image: require("../../assets/Mentality/NieuweConservatieven/image3.jpg"),
        },
        {
          image: require("../../assets/Mentality/NieuweConservatieven/image4.jpg"),
        },
        {
          image: require("../../assets/Mentality/NieuweConservatieven/image5.jpg"),
        },
        {
          image: require("../../assets/Mentality/NieuweConservatieven/image6.jpg"),
        },
        {
          image: require("../../assets/Mentality/NieuweConservatieven/image7.jpg"),
        },
        {
          image: require("../../assets/Mentality/NieuweConservatieven/image8.jpg"),
        },
        {
          image: require("../../assets/Mentality/NieuweConservatieven/image9.jpg"),
        },
      ],
      traditioneleBurgerij: [
        {
          image: require("../../assets/Mentality/TraditioneleBurgerij/image1.jpg"),
        },
        {
          image: require("../../assets/Mentality/TraditioneleBurgerij/image2.jpg"),
        },
        {
          image: require("../../assets/Mentality/TraditioneleBurgerij/image3.jpg"),
        },
        {
          image: require("../../assets/Mentality/TraditioneleBurgerij/image4.jpg"),
        },
        {
          image: require("../../assets/Mentality/TraditioneleBurgerij/image5.jpg"),
        },
        {
          image: require("../../assets/Mentality/TraditioneleBurgerij/image6.jpg"),
        },
        {
          image: require("../../assets/Mentality/TraditioneleBurgerij/image7.jpg"),
        },
        {
          image: require("../../assets/Mentality/TraditioneleBurgerij/image8.jpg"),
        },
        {
          image: require("../../assets/Mentality/TraditioneleBurgerij/image9.jpg"),
        },
      ],
      kosmopolieten: [
        { image: require("../../assets/Mentality/Kosmopolieten/image1.jpg") },
        { image: require("../../assets/Mentality/Kosmopolieten/image2.jpg") },
        { image: require("../../assets/Mentality/Kosmopolieten/image3.jpg") },
        { image: require("../../assets/Mentality/Kosmopolieten/image4.jpg") },
        { image: require("../../assets/Mentality/Kosmopolieten/image5.jpg") },
        { image: require("../../assets/Mentality/Kosmopolieten/image6.jpg") },
        { image: require("../../assets/Mentality/Kosmopolieten/image7.jpg") },
        { image: require("../../assets/Mentality/Kosmopolieten/image8.jpg") },
        { image: require("../../assets/Mentality/Kosmopolieten/image9.jpg") },
      ],
      postmoderneHedonisten: [
        {
          image: require("../../assets/Mentality/PostmoderneHedonisten/image1.jpg"),
        },
        {
          image: require("../../assets/Mentality/PostmoderneHedonisten/image2.jpg"),
        },
        {
          image: require("../../assets/Mentality/PostmoderneHedonisten/image3.jpg"),
        },
        {
          image: require("../../assets/Mentality/PostmoderneHedonisten/image4.jpg"),
        },
        {
          image: require("../../assets/Mentality/PostmoderneHedonisten/image5.jpg"),
        },
        {
          image: require("../../assets/Mentality/PostmoderneHedonisten/image6.jpg"),
        },
        {
          image: require("../../assets/Mentality/PostmoderneHedonisten/image7.jpg"),
        },
        {
          image: require("../../assets/Mentality/PostmoderneHedonisten/image8.jpg"),
        },
        {
          image: require("../../assets/Mentality/PostmoderneHedonisten/image9.jpg"),
        },
      ],
      gemaksgeorienteerden: [
        {
          image: require("../../assets/Mentality/Gemaksgeorienteerden/image1.jpg"),
        },
        {
          image: require("../../assets/Mentality/Gemaksgeorienteerden/image2.jpg"),
        },
        {
          image: require("../../assets/Mentality/Gemaksgeorienteerden/image3.jpg"),
        },
        {
          image: require("../../assets/Mentality/Gemaksgeorienteerden/image4.jpg"),
        },
        {
          image: require("../../assets/Mentality/Gemaksgeorienteerden/image5.jpg"),
        },
        {
          image: require("../../assets/Mentality/Gemaksgeorienteerden/image6.jpg"),
        },
        {
          image: require("../../assets/Mentality/Gemaksgeorienteerden/image7.jpg"),
        },
        {
          image: require("../../assets/Mentality/Gemaksgeorienteerden/image8.jpg"),
        },
        {
          image: require("../../assets/Mentality/Gemaksgeorienteerden/image9.jpg"),
        },
      ],
    };

    // Compute all images based on popup content
    const allImages = computed(() => {
      switch (props.popupContent.title) {
        case "Moderne burgerij":
          return images.moderneBurgerij;

        case "Opwaarts mobielen":
          return images.opwaartsMobielen;

        case "Postmaterialisten":
          return images.postMaterialisten;

        case "Nieuwe conservatieven":
          return images.nieuweConservatieven;

        case "Traditionele burgerij":
          return images.traditioneleBurgerij;

        case "Kosmopolieten":
          return images.kosmopolieten;

        case "Postmoderne hedonisten":
          return images.postmoderneHedonisten;

        case "Gemaksgeorienteerden":
          return images.gemaksgeorienteerden;

        default:
          return [];
      }
    });

    // Return reactive properties and computed property for the template
    return {
      url,
      allImages,
    };
  },
};
</script>

<style lang="sass" scoped>
div
  .video-wrapper
    display: flex
    direction: ltr
    width: 100%
    .video
      width: 300px
      height: 200px
      object-fit: cover
      border-radius: 15px
      border: none
    .text
      // margin-left: 80px
      display: flex
      flex-direction: column
      // justify-content: center
      width: 134px
      .perc
        margin-top: 17px
        margin-bottom: 7px
        width: 55px
        border-radius: 17.5px
        color: white
        font-size: 18px
        line-height: 38px
        text-align: center
      .body
        margin: 0
        font-size: 15px
        line-height: 25px
        padding: 0
  p
    margin: 0
  .title
    direction: ltr
    font-size: 28px
    line-height: 38px
    margin-top: 10px
    margin-bottom: 20px
  .body
    direction: ltr
    font-size: 15px
    line-height: 22px
    width: 100%
  .row
    margin-top: 20px
    direction: ltr
    display: flex
    flex-direction: row
    flex-wrap: wrap
    width: 100%
    .image
      width: 190px
      height: 190px
      margin-right: 20px
      margin-bottom: 20px
      &:nth-child(3)
        margin-right: 0
      .img
        background-size: cover
        background-position: center center
        width: 100%
        height: 100%
        border-radius: 15px
  &.white
    .video-wrapper
      .video
      .grey
        background: #92A7B4
      .green
        background: linear-gradient(270deg, #3FBEB1 0%, #009987 100%)
      .purple
        background: linear-gradient(90deg, #964380 0%, #BE78AB 100%)
      .text
        margin-left: 80px
        justify-content: center

  @media only screen and (min-width: 1660px)
    .popupMoodboard
      width: 50%
</style>
